export default __webpack_public_path__ + "static/media/tbts1.f6e58212.png";